import "@/CSS/news/newsDetails";

import $ from 'jquery';
//引入导航
import newNav from "../../util/newNav";
import footers from "../../util/footer";


//添加导航
const newNAv = newNav();
$('body').append(newNAv);
const publicfooters = footers();
$('body').append(publicfooters);

let newsId;

$(document).ready(function () {
    // 获取当前 URL 的查询参数部分
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    newsId = urlParams.get('newsId');
    getNewsDetail(newsId);
    hotNews();
})

function getNewsDetail(newsId) {
    $.ajax({
        url: '/singleSignLogin/salary-api/api/website/news/newsBean',
        type: 'get',
        headers: {
            'Content-Type': 'application/json',
            'Authtoken': localStorage.getItem('token')
        },
        data: {
            id: newsId,
        },
        dataType: 'json',
        success: function (res) {
            if (res.code == 200) {
                let data = res.data;
                console.log(data);
                $('#header').html(data.title);
                $('#time').html(data.updateTime);
                $('#content').html(data.content);
            }
        },
        error: function (res) {
            console.log(res)
        }
    })
}

function hotNews() {
    $.ajax({
        url: '/singleSignLogin/salary-api/api/website/news/getListPageBack?&page=1&limit=10&title=&newsCategoryId=1656516083523328',
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            if (data.code === 200) {
                let hotNewsnewsList = data.data.records;
                $.each(hotNewsnewsList, function (index, item) {
                    let hotNews = `
                                <a href="./newsDetails.html?newsId=${item.id}" class="block hover:text-green-500">${item.title}</a>
                              `
                    $("#hotNews").append(hotNews);
                })
            }
        },
        error: function (error) {
            console.error('Error fetching category list:', error);
        }
    });
}